// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminOpticomm = (client) => ({
    /**
     * `POST /admin/opticomm/sales-channels/:id/products`
     *
     * @operationId AdminOpticommPostSalesChannelsIdProducts
     * @source packages/modules/b2c-core/src/api/admin/opticomm/sales-channels/[id]/products/route.ts
     */
    createSalesChannelsProduct: (id, body, query, headers) => client.fetch(buildPath("/admin/opticomm/sales-channels/:id/products", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/opticomm/products/:id/sample-variant`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommDisableProductSampleVariant
     * @source packages/modules/b2c-core/src/api/admin/opticomm/products/[id]/sample-variant/route.ts
     */
    deleteProductsSampleVariant: (id, body, query, headers) => client.fetch(buildPath("/admin/opticomm/products/:id/sample-variant", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/opticomm/try-on/settings`
     *
     * @operationId AdminOpticommTryOnSettingsGet
     * @source apps/backend/src/api/admin/opticomm/try-on/settings/route.ts
     */
    getTryOnSettings: (query, headers) => client.fetch("/admin/opticomm/try-on/settings", { method: "GET", query, headers }),
    /**
     * `GET /admin/opticomm/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommListProducts
     * @source packages/modules/b2c-core/src/api/admin/opticomm/products/route.ts
     */
    listProducts: (query, headers) => client.fetch("/admin/opticomm/products", { method: "GET", query, headers }),
    /**
     * `GET /admin/opticomm/try-on/audit-events`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommTryOnAuditEventsList
     * @source apps/backend/src/api/admin/opticomm/try-on/audit-events/route.ts
     */
    listTryOnAuditEvents: (query, headers) => client.fetch("/admin/opticomm/try-on/audit-events", { method: "GET", query, headers }),
    /**
     * `GET /admin/opticomm/try-on/usage`
     *
     * @operationId AdminOpticommTryOnUsageList
     * @source apps/backend/src/api/admin/opticomm/try-on/usage/route.ts
     */
    listTryOnUsage: (query, headers) => client.fetch("/admin/opticomm/try-on/usage", { method: "GET", query, headers }),
    /**
     * `GET /admin/opticomm/vendor-reports`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommVendorReportsList
     * @source apps/backend/src/api/admin/opticomm/vendor-reports/route.ts
     */
    listVendorReports: (query, headers) => client.fetch("/admin/opticomm/vendor-reports", { method: "GET", query, headers }),
    /**
     * `GET /admin/opticomm/publishable-keys/:id/storefront`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommPublishableKeyStorefrontGet
     * @source apps/backend/src/api/admin/opticomm/publishable-keys/[id]/storefront/route.ts
     */
    retrievePublishableKeysStorefront: (id, query, headers) => client.fetch(buildPath("/admin/opticomm/publishable-keys/:id/storefront", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/opticomm/products/:id/sample-variant`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommEnableProductSampleVariant
     * @source packages/modules/b2c-core/src/api/admin/opticomm/products/[id]/sample-variant/route.ts
     */
    updateProductsSampleVariant: (id, body, query, headers) => client.fetch(buildPath("/admin/opticomm/products/:id/sample-variant", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/opticomm/publishable-keys/:id/storefront`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommPublishableKeyStorefrontUpsert
     * @source apps/backend/src/api/admin/opticomm/publishable-keys/[id]/storefront/route.ts
     */
    updatePublishableKeysStorefront: (id, body, query, headers) => client.fetch(buildPath("/admin/opticomm/publishable-keys/:id/storefront", [id]), { method: "POST", body, query, headers }),
    /**
     * `PUT /admin/opticomm/try-on/settings`
     *
     * @operationId AdminOpticommTryOnSettingsUpdate
     * @source apps/backend/src/api/admin/opticomm/try-on/settings/route.ts
     */
    updateTryOnSettings: (body, query, headers) => client.fetch("/admin/opticomm/try-on/settings", { method: "PUT", body, query, headers }),
    /**
     * `PUT /admin/opticomm/vendor-reports/:seller_id/:report_type`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminOpticommVendorReportUpdate
     * @source apps/backend/src/api/admin/opticomm/vendor-reports/[seller_id]/[report_type]/route.ts
     */
    updateVendorReport: (sellerId, reportType, body, query, headers) => client.fetch(buildPath("/admin/opticomm/vendor-reports/:seller_id/:report_type", [sellerId, reportType]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=opticomm.js.map